const questions = { 
			"1" : {
				"text" 		: "Etes vous bénéficiaire <b>du RSA socle</b> (quelque soit le montant) ou du <b>RSA jeune</b> au mois de novembre ou décembre 2024 ?",
				"type"		: "radio",
				"options"	: [ "Oui" , "Non"],
				"optionals" 	: {
					"1": {
						"text" 		: "Vivez vous seul ou en couple ?",
						"type"		: "radio",
						"options"	: [ "Je vis seul" , "Je vis en couple"]
					},
					"2" : {
						"text" : "Avez-vous des enfants ? ",
						"type" : "select",
						"options" : [
							{ "text" : "Personne seule sans enfant" , "value" : "152,45 &euro;"},
							{ "text" : "Personne seule avec 1 enfant" , "value" : "228,67 &euro;"},
							{ "text" : "Personnes seule avec 2 enfant" , "value" : "274,40 &euro;"},
							{ "text" : "Personne seule avec 3 enfant" , "value" : "336,39 &euro;"},
							{ "text" : "Personne seule avec 4 enfants" , "value" : "396,37 &euro;"},
							{ "text" : "Personne seule avec plus de 4 enfants à charge" , "value" : "396,37 &euro; + 60,98 &euro; par enfant supplémentaire <br/>"},
							{ "text" : "Couple sans enfant" , "value" : "228,67 &euro;"},
							{"text" : "Couple avec 1 enfant", "value" : " 274,40 &euro;"},
							{"text" : "Couple avec 2 enfants", "value" : "320,14 &euro;"},
							{"text" : "Couple avec 3 enfants", "value" : "381,12 &euro;"},
							{"text" : "Couple avec 4 enfants", "value" : "442,10 &euro;"},
							{"text" : "Couple avec plus de 4 enfants", "value" : "442,10 &euro; + 60,98 &euro; par enfant supplémentaire <br/>"}
						]
						
					}

				} 
			},
			"2" : {
				"text" : "Etes vous bénéficiaire de l'ASS à taux simple au mois de novembre ou décembre 2024 ?",
				"type"		: "radio",
				"options"	: [ "Oui" , "Non" ],
				"optionals" 	: {
					"1": {
						"text" 		: "Vivez vous seul ou en couple ?",
						"type"		: "radio",
						"options"	: [ "Je vis seul" , "Je vis en couple"]
					},
					"2" : {
						"text" : "Avez-vous des enfants ? ",
						"type" : "select",
						"options" : [
							{ "text" : "Personne seule sans enfant" , "value" : "152,45 &euro;"},
							{ "text" : "Personne seule avec 1 enfant" , "value" : "228,67 &euro;"},
							{ "text" : "Personnes seule avec 2 enfant" , "value" : "274,40 &euro;"},
							{ "text" : "Personne seule avec 3 enfant" , "value" : "335,39 &euro;"},
							{ "text" : "Personne seule avec 4 enfants" , "value" : "396,37 &euro;"},
							{ "text" : "Personne seule avec plus de 4 enfants à charge" , "value" : "396,37 &euro; + 60,98 &euro; par enfant supplémentaire <br/>"},
							{ "text" : "Couple sans enfant" , "value" : "228,67 &euro;"},
							{"text" : "Couple avec 1 enfant", "value" : " 274,40 &euro;"},
							{"text" : "Couple avec 2 enfants", "value" : "320,14 &euro;"},
							{"text" : "Couple avec 3 enfants", "value" : "381,12 &euro;"},
							{"text" : "Couple avec 4 enfants", "value" : "442,10 &euro;"},
							{"text" : "Couple avec plus de 4 enfants", "value" : "442,10 &euro; + 60,98 &euro; par enfant supplémentaire <br/>"}
						]
						
					}

				} 
			},
			"3" : {
				"text" : "Suite à une indemnisation au titre de l'ASS, <b>êtes-vous bénéficiaire au mois de novembre ou décembre de l'une des aides suivantes</b> : Rémunération publique de stage, rémunération de formation France Travail ou ACCRE-ASS ? ",
				"type"		: "radio",
				"options"	: [ "Oui" , "Non"],
				"optionals" 	: {
					"1": {
						"text" 		: "Vivez vous seul ou en couple ?",
						"type"		: "radio",
						"options"	: [ "Je vis seul" , "Je vis en couple"]
					},
					"2" : {
						"text" : "Avez-vous des enfants ? ",
						"type" : "select",
						"options" : [
							{ "text" : "Personne seule sans enfant" , "value" : "152,45 &euro;"},
							{ "text" : "Personne seule avec 1 enfant" , "value" : "228,67 &euro;"},
							{ "text" : "Personnes seule avec 2 enfant" , "value" : "274,40 &euro;"},
							{ "text" : "Personne seule avec 3 enfant" , "value" : "335,39 &euro;"},
							{ "text" : "Personne seule avec 4 enfants" , "value" : "396,37 &euro;"},
							{ "text" : "Personne seule avec plus de 4 enfants à charge" , "value" : "396,37 &euro; + 60,98 &euro; par enfant supplémentaire <br/>"},
							{ "text" : "Couple sans enfant" , "value" : "228,67 &euro;"},
							{"text" : "Couple avec 1 enfant", "value" : " 274,40 &euro;"},
							{"text" : "Couple avec 2 enfants", "value" : "320,14 &euro;"},
							{"text" : "Couple avec 3 enfants", "value" : "381,12 &euro;"},
							{"text" : "Couple avec 4 enfants", "value" : "442,10 &euro;"},
							{"text" : "Couple avec plus de 4 enfants", "value" : "442,10 &euro; + 60,98 &euro; par enfant supplémentaire <br/>"}
						]
						
					}

				} 
			},
			"4" :{
				"text" : "Etes vous bénéficiaire de l'Allocation Equivalent Retraite au mois de novembre ou décembre 2024 ?",
				"type"		: "radio",
				"options"	: [ "Oui" , "Non"],
				"optionals" 	: {
					"1": {
						"text" 		: "Vivez vous seul ou en couple ?",
						"type"		: "radio",
						"options"	: [ "Je vis seul" , "Je vis en couple"]
					},
					"2" : {
						"text" : "Avez-vous des enfants ? ",
						"type" : "select",
						"options" : [
							{ "text" : "Personne seule sans enfant" , "value" : "152,45 &euro;"},
							{ "text" : "Personne seule avec 1 enfant" , "value" : "228,67 &euro;"},
							{ "text" : "Personnes seule avec 2 enfant" , "value" : "274,40 &euro;"},
							{ "text" : "Personne seule avec 3 enfant" , "value" : "335,39 &euro;"},
							{ "text" : "Personne seule avec 4 enfants" , "value" : "396,37 &euro;"},
							{ "text" : "Personne seule avec plus de 4 enfants à charge" , "value" : "396,37 &euro; + 60,98 &euro; par enfant supplémentaire <br/>"},
							{ "text" : "Couple sans enfant" , "value" : "228,67 &euro;"},
							{"text" : "Couple avec 1 enfant", "value" : " 274,40 &euro;"},
							{"text" : "Couple avec 2 enfants", "value" : "320,14 &euro;"},
							{"text" : "Couple avec 3 enfants", "value" : "381,12 &euro;"},
							{"text" : "Couple avec 4 enfants", "value" : "442,10 &euro;"},
							{"text" : "Couple avec plus de 4 enfants", "value" : "442,10 &euro; + 60,98 &euro; par enfant supplémentaire <br/>"}
						]
						
					}

				} 
			}
		};
export {questions};